

/**
 * 打印日志
 * @param  {...any} params 
 */
function printLog(...params) {
  console.log(...params);
}

/**
 * 检查是否在PC中
 */
export function inPc() {
  return !!window.pcBridge;
}

/**
 * 执行桥接方法
 * @param {*} func 方法名称
 * @param {*} params 参数信息
 * @param {*} listener 事件监听
 * @returns 返回promise
 */
export function bridgeCall(func, params, listener) {
  printLog("bridgeCall", func, params);
  return new Promise((resolve, reject) => {
    if (window.pcBridge) {
      window.pcBridge.call(func, params, (resp) => {
        if (resp.success) {
          resolve(resp.result);
        } else {
          reject(resp.error);
        }
      }, (data) => {
        printLog("bridgeCallEvent", func, data.event);
        listener && listener(data.event)
      });
    } else {
      reject("not in pc client");
    }
  })
}

export function closeWindow() {
  if (!inPc()) {
    window.opener = null;
    window.open('', '_self');
    window.close();
  } else {
    bridgeCall("closeWindow", {});
  }
}